import { useState } from "react"
import "./multi-content-picker.component.css"

const MultiContentPickerComponent = (props) => {
  const { Heading, Items } = props
  const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <div className="dagger-multi-content-picker">
      <h2>{Heading}</h2>
      <ul className="dagger-multi-content-picker-content">
        {Items?.map((i, index) => {
          return (
            <li
              key={i.id}
              className={selectedIndex === index ? "selected" : ""}
              onClick={() => setSelectedIndex(index)}
            >
              <h5>{i.Heading}</h5>
              <div
                className="dagger-multi-content-picker-selected"
                dangerouslySetInnerHTML={{ __html: i.Copy }}
              />
            </li>
          )
        })}
      </ul>
      {/* <div className="dagger-multi-content-picker-image">
          <img
            src={Items[selectedIndex].Media.data.attributes.url}
            alt={Items[selectedIndex].Media.data.attributes.alternateText}
          />
        </div> */}
    </div>
  )
}

export default MultiContentPickerComponent
